import PartnerScreen from "../../screens/Partner/SignupScreen/SignupScreen"

export { getStaticProps } from "../../screens/Partner/SignupScreen/data"

export default PartnerScreen
